import { render, staticRenderFns } from "./IconUploadModal.vue?vue&type=template&id=33a9aaa4&scoped=true&"
import script from "./IconUploadModal.vue?vue&type=script&lang=js&"
export * from "./IconUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9aaa4",
  null
  
)

export default component.exports